import { USER_KEY } from '../helpers/storage';
import { TOGGLE_PROFILE_FAVORITES, } from '../actions/profile';

import {
  fetchUserConfigurationActionTypes,
  updateUserConfigurationActionTypes
} from '../actions/types';

/*const defTabs = [
  {
    name: 'Build', options: [
      { route: '/build', name: 'Build' },
      { route: '/build-health', name: 'Build Health' },
      { route: '/node-health', name: 'Node Health' }
    ]
  },
  {
    name: 'Metrics', options: [
      { route: '/case-metrics', name: 'Case Metrics' },
      { route: '/engine-metrics', name: 'Engine Metrics' },
      { route: '/performance', name: 'Performance Metrics' },
      { route: '/artifacts-metrics', name: 'Artifacts Metrics' },
      { route: '/artifact-stats', name: 'Artifact Statistics' },
      { route: '/jira-metrics', name: 'Jira Metrics' },
      { route: '/artifact-health', name: 'Artifact Health' },
      { route: '/release-metrics', name: 'Release Metrics' },
      { route: '/aws-instances-cost', name: 'AWS Instances Cost' }
    ]
  },
  {
    name: 'Regressions', options: [
      { route: '/white', name: 'White Tests' },
      { route: '/test-studio', name: 'Test Studio Tests' },
      { route: '/case-merging', name: 'Case Merging Tests' },
      { route: '/case-amending', name: 'Case Amending Tests' },
      { route: '/artifact-regression', name: 'Artifact Regression' },
      { route: '/diff', name: 'Diff Tool Regression' },
      { route: '/export-regression', name: 'Export Regression' },
      { route: '/remote-acquire-regression', name: 'Remote Acquire Regression' },
      { route: '/installer', name: 'Installer Tests' },
      { route: '/axiom-ui', name: 'Axiom UI Tests' }
    ]
  },
  { route: '/cloud', name: 'Cloud' },
  { route: '/acquisition', name: 'Acquisition' },
  {
    name: 'Telemetry', options: [
      { route: '/telemetry-process', name: 'Process' },
      { route: '/telemetry-examine', name: 'Examine' },
      { route: '/telemetry-axiom-scans-today', name: 'Axiom Scans Today' }
    ]
  },
  { route: '/prtg', name: 'PRTG Status' },
];*/

const initialState = {
  notifications: { favoritesOnly: false },
  userConfiguration: {
    username: '',
    muteToasts: false,
    darkMode: localStorage.getItem('dark') === 'true',
    customNav: [
      {
        name: 'Build', options: [
          { route: '/build', name: 'Build' },
          { route: '/build-health', name: 'Build Health' },
          { route: '/node-health', name: 'Node Health' }
        ]
      },
      {
        name: 'Metrics', options: [
          { route: '/case-metrics', name: 'Case Metrics' },
          { route: '/engine-metrics', name: 'Engine Metrics' },
          { route: '/performance', name: 'Performance Metrics' },
          { route: '/artifacts-metrics', name: 'Artifacts Metrics' },
          { route: '/artifact-stats', name: 'Artifact Statistics' },
          { route: '/jira-metrics', name: 'Jira Metrics' },
          { route: '/artifact-health', name: 'Artifact Health' },
          { route: '/release-metrics', name: 'Release Metrics' },
          { route: '/aws-instances-cost', name: 'AWS Instances Cost' }
        ]
      },
      {
        name: 'Regressions', options: [
          { route: '/white', name: 'White Tests' },
          { route: '/test-studio', name: 'Test Studio Tests' },
          { route: '/case-merging', name: 'Case Merging Tests' },
          { route: '/case-amending', name: 'Case Amending Tests' },
          { route: '/artifact-regression', name: 'Artifact Regression' },
          { route: '/diff', name: 'Diff Tool Regression' },
          { route: '/export-regression', name: 'Export Regression' },
          { route: '/remote-acquire-regression', name: 'Remote Acquire Regression' },
          { route: '/installer', name: 'Installer Tests' },
          { route: '/axiom-ui', name: 'Axiom UI Tests' }
        ]
      },
      { route: '/cloud', name: 'Cloud' },
      { route: '/acquisition', name: 'Acquisition' },
      {
        name: 'Telemetry', options: [
          { route: '/telemetry-process', name: 'Process' },
          { route: '/telemetry-examine', name: 'Examine' },
          { route: '/telemetry-axiom-scans-today', name: 'Axiom Scans Today' }
        ]
      },
      { route: '/prtg', name: 'PRTG Status' },
    ],
  }
};

const profile = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_PROFILE_FAVORITES:
      return {
        ...state,
        notifications: { favoritesOnly: !state.notifications.favoritesOnly }
      };

    case fetchUserConfigurationActionTypes.success:
    // If the user is logged in, the configuration exists, and was fetched successfully
      if (action.response) {
        return {
          ...state,
          userConfiguration: convertUserConfiguration(action.response)
        };
      }
      // If the user is not logged in OR is logged in but the configuration
      // does not exist.
      else
        return {
          ...initialState,
          userConfiguration: {
            ...initialState.userConfiguration,
            username: localStorage.getItem(USER_KEY)
          }
        };

    case updateUserConfigurationActionTypes.success:
      return {
        ...state,
        userConfiguration: action.response
      };
    default:
      return state;
  }
};

/**
 *
 * Converts a UserConfiguration object to a format that is compatible with the
 * redux store.
 *
 * @param {Object} userConfiguration - The user configuration object from the backend.
 * @returns A userConfiguration object to be stored in the Redux state.
 */
const convertUserConfiguration = (userConfiguration) => {
  return {
    'username': userConfiguration.username,
    'darkMode': userConfiguration.is_dark_mode_enabled,
    'muteToasts': userConfiguration.is_toast_muted,
    'customNav': userConfiguration.custom_nav
  };
};

export default profile;

export const getProfileFavoritesOnly = (state) =>
  state.profile.notifications.favoritesOnly;

export const getUserConfiguration = (state) =>
  state.profile.userConfiguration;

export const isDarkMode = (state) =>
  getUserConfiguration(state).darkMode;

export const isToastMuted = (state) =>
  getUserConfiguration(state).muteToasts;

export const customNav = (state) =>
  getUserConfiguration(state).customNav;


// WEBPACK FOOTER //
// src/reducers/profile.js